// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2FyuC","col":"styles_col__3U8dU","fulfillmentStatus":"styles_fulfillmentStatus__1vEdm","emailCol":"styles_emailCol__1Kf4T"};